import { Check, CheckSharp, CopyAll } from '@mui/icons-material';
import { Alert, Box, Button, Snackbar, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { fetchTokenAsync, selectJwt } from '../auth/AuthSlice';

const JwtToken = () => {
  const [copied, setCopied] = useState<boolean>(false);
  const [expiryTime, setExpiryTime] = useState<string>('');
  const dispatch = useAppDispatch();
  const jwt = useAppSelector(selectJwt);

  useEffect(() => {
    if (jwt) {
      try {
        const payload = JSON.parse(atob(jwt.split('.')[1]));
        if (payload.exp) {
          const expiryDate = new Date(payload.exp * 1000);
          setExpiryTime(expiryDate.toLocaleString());
        }
      } catch (error) {
        console.error('Error decoding token:', error);
      }
    } else {
      dispatch(fetchTokenAsync());
    }
  }, [dispatch, jwt]);
  const handleCopied = () => {
    setCopied(true)
    setTimeout(() => { setCopied(false) }, 6000)
  }
  const handleCloseCopied = () => { setCopied(false) }
  return (
    <Box>
      <h1>JWT Token</h1>
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <Typography sx={{ width: '100%', overflowWrap: 'anywhere' }}>{jwt}</Typography>
        {expiryTime && (
          <Typography variant="body2" sx={{ mt: 2, fontWeight: 'bold', color: 'gray' }}>
            Expires At: {expiryTime}
          </Typography>
        )}
        {jwt ? <CopyToClipboard text={jwt} onCopy={handleCopied} >
          <Button variant='contained' size='small' color={copied ? "success" : "primary"} sx={{
            textTransform: 'none', fontSize: 12, height: 36, width: '125px', mt: 4
          }}>
            {copied ? <CheckSharp sx={{ fontSize: 12, mr: 1 }} /> :
              <CopyAll sx={{ fontSize: 12, mr: 1 }} />} Copy Token
          </Button>
        </CopyToClipboard> : <></>}
      </Box>
      <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'right' }} open={copied} autoHideDuration={6000} onClose={handleCloseCopied}>
        <Alert icon={<Check fontSize="inherit" />} onClose={handleCloseCopied} sx={{ width: '100%' }}>
          Copied!
        </Alert>
      </Snackbar>
    </Box>
  )
};

export default JwtToken;